export const JOB_STATUSES = [
  "Queued",
  "Admitted",
  "Running",
  "Succeeded",
  "Failed",
  "Timeout",
  "Cancelled",
];
export const EMPTY_FILTERS = {
  name: "",
  statuses: [],
  time: { preset: "all", from: "", to: "" },
};
export const TIME_LABELS = {
  all: "All time",
  week: "Last 7 days",
  month: "Last month",
  sixMonths: "Last 6 months",
};

export function localDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value))
    throw new Error("Enter a valid date.");
  const [year, month, day] = value.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  )
    throw new Error("Enter a valid date.");
  return date;
}
export function dateText(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}
export function timeBounds(time, now = new Date()) {
  if (time.preset === "all") return {};
  let from, to;
  if (time.preset === "custom") {
    from = time.from ? localDate(time.from) : null;
    to = time.to ? localDate(time.to) : null;
    if (from && to && from > to)
      throw new Error("From must be on or before To.");
  } else {
    to = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    from = new Date(to);
    if (time.preset === "week") from.setDate(from.getDate() - 6);
    else {
      const day = from.getDate();
      from.setDate(1);
      from.setMonth(from.getMonth() - (time.preset === "month" ? 1 : 6));
      const lastDay = new Date(
        from.getFullYear(),
        from.getMonth() + 1,
        0,
      ).getDate();
      from.setDate(Math.min(day, lastDay));
    }
  }
  if (to) to.setDate(to.getDate() + 1);
  return {
    ...(from && { submitted_from: from.toISOString() }),
    ...(to && { submitted_before: to.toISOString() }),
  };
}
export function jobListPath(filters, now) {
  const params = new URLSearchParams();
  if (filters.name) params.set("name_substr", filters.name);
  filters.statuses.forEach((status) => params.append("status", status));
  Object.entries(timeBounds(filters.time, now)).forEach(([key, value]) =>
    params.set(key, value),
  );
  const query = params.toString();
  return `/jobs/list${query ? `?${query}` : ""}`;
}
